import { heDecodeOrDefault } from "~/lib/shared/html-utils";
import { Author } from "~/types/asgard/Author";
import { ArticleBylineProps } from "./ArticleByline";

/** Returning true indicates it is a valid date string */
const isValidDate = (dateString: string | null): dateString is string =>
  dateString ? Number.isFinite(new Date(dateString).getTime()) : false;

export const apiToArticleBylineProps = (
  apiData: Author[],
  isoPublishDate: string | null
): ArticleBylineProps | null => {
  const authorsList = apiData.map((authorItem) => {
    const niceName = heDecodeOrDefault(authorItem.author_nicename);
    return {
      authorName: heDecodeOrDefault(authorItem.display_name),
      authorTitle: heDecodeOrDefault(authorItem.author_title),
      href: niceName ? `/authors/${niceName}` : "",
      headshotImageUrl:
        authorItem.author_thumbnail?.sizes?.full.source_url || null,
    };
  });

  const publishDate = isValidDate(isoPublishDate) ? isoPublishDate : null;

  if (authorsList.length === 0) {
    if (!publishDate) {
      return null;
    }
    return {
      authorsList: [],
      publishDate,
    };
  }

  return {
    authorsList,
    publishDate,
  };
};
